module.exports = __webpack_public_path__ + "img/stuDetailIcon4@2x.46c6f2b7.png";